import { ADMIN_ROUTES } from './adminRoutes';
import { USER_ROLES, type UserRole } from './roles';

/** Public authentication routes shared across all layouts. */
export const LOGIN_ROUTE = '/login' as const;

/** Landing route of the tenant app. */
export const DASHBOARD_ROUTE = '/dashboard' as const;

/** Each role's "home": the super-admin console for SuperAdmin, the tenant dashboard otherwise. */
const ROLE_HOME_ROUTES = {
  [USER_ROLES.SUPER_ADMIN]: ADMIN_ROUTES.root,
  [USER_ROLES.TENANT_ADMIN]: DASHBOARD_ROUTE,
  [USER_ROLES.TENANT_MEMBER]: DASHBOARD_ROUTE,
} as const satisfies Record<UserRole, string>;

/** Every route that is some role's home. */
export const ROLE_HOME_PATHS: ReadonlySet<string> = new Set(Object.values(ROLE_HOME_ROUTES));

/** Where a signed-in user's "home" lives; an unknown or missing role falls back to the tenant dashboard. */
export const homeRouteForRole = (role: string | undefined): string =>
  role && Object.hasOwn(ROLE_HOME_ROUTES, role) ? ROLE_HOME_ROUTES[role as UserRole] : DASHBOARD_ROUTE;
